/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

/*
 * @format
 */
import { ScrollToHelper } from 'sarsaparilla';
import get from 'lodash/get';
import { gnoment } from 'shared-ui/gnoment';
import { PRICE_MAGNITUDE } from '../constants';
import { eventTypes } from '../constants/recurring';

export const getClassName = (error, displayError) => {
    if (error && displayError) {
        return 'rec-error';
    }
    return '';
};

export function capitalize(str = '') {
    return `${str.charAt(0).toUpperCase()}${str.slice(1)}`;
}

export const scrollUp = ({ top = 0, left = 0 } = {}) =>
    ScrollToHelper.scrollTo(top, left);

export const formatPrice = (value = 0) => `$${(value / PRICE_MAGNITUDE).toFixed(2)}`;

export const initialReservation = {
    account_id: null,
    order_id: null,
    facility_id: null,
    permit_type_id: null,
    price: 0,
    clin: 0,
    sku: '',
    quantity: 0,
    point_of_sale: 'web',
    status: 'pending',
    created_at: null,
    updated_at: null,
    is_pending: true,
    holder_info: {
        first_name: null,
        last_name: null,
        email: null,
    },
    trees_number: null,
    ekopass: null,
    has_price: true,
    fees: null,
    total: null,
};

export const getVenueRecurringReservations = (reservations) => {
    let response = [];

    for (let i = 0; i < reservations.length; i++) {
        if (
            (reservations[i].inventory_type === 'VENUE_RESERVATIONS' ||
                reservations[i].inventory_type === 'VENUE_APPLICATION') &&
            reservations[i]?.order_details?.recurrence_id
        ) {
            const current = response.find(
                (item) =>
                    item?.order_details?.recurrence_id ===
                    reservations[i].order_details?.recurrence_id
            );
            if (current) {
                response = response.map((item) => {
                    if (
                        item?.order_details?.recurrence_id ===
                        reservations[i].order_details?.recurrence_id
                    ) {
                        return {
                            ...item,
                            order_details: {
                                ...item?.order_details,
                                dates: [
                                    ...item?.order_details?.dates,
                                    reservations[i]?.order_details?.event_date,
                                ],
                            },
                            subtotal:
                                Number(item.subtotal) + Number(reservations[i].subtotal),
                        };
                    }
                    return item;
                });
            } else {
                const updated = reservations[i];
                response = [
                    ...response,
                    {
                        ...updated,
                        order_details: {
                            ...updated?.order_details,
                            dates: [updated?.order_details?.event_date],
                            subtotal: Number(updated.subtotal),
                        },
                    },
                ];
            }
        } else {
            response = [...response, reservations[i]];
        }
    }

    return response;
};

export const getVenueReservationsSorted = (reservations) => {
    const venueReservations = reservations
        ?.filter((item) => item.inventory_type === 'VENUE_RESERVATIONS')
        .sort(
            (a, b) =>
                gnoment(a.order_details.event_date).valueOf() -
                gnoment(b.order_details.event_date).valueOf()
        );
    const regularReservations = reservations?.filter(
        (item) => item.inventory_type !== 'VENUE_RESERVATIONS'
    );
    const response = [...venueReservations, ...regularReservations];
    return response;
};

export const getEventTypeByValue = (value = '') => {
    return eventTypes.find((e) => e.value === value);
};

export const parseError = (error, defaultErr) => {
    const errorStr = get(error, 'message', '');
    if (errorStr) {
        return errorStr;
    }
    return defaultErr;
};

export const findEventTypeByValueOrLabel = (events, eventType) => {
    return (
        events.find((type) => type.value === eventType) ||
        events.find((type) => type.label === eventType)
    );
};
